export const environment = {
  production: true,
  publisher: 'edb',
  // urlPortale: 'https://www.dehoniane.it',
  // syncUrlPortale: 'https://www.dehoniane.it/transcode/importSingleBookEvo',
  // syncCoversPortale: 'https://www.dehoniane.it/transcode/importCovers',

  urlPortale: 'https://www.edb.it',
  syncUrlPortale: 'https://www.edb.it/transcode/importbook',
  syncCoversPortale: 'https://www.edb.it/transcode/importCovers',

  server: {
    url: 'https://elzeviro-edb.ilporticoeditoriale.it:3030'
  },
  copertinario: {
    media: 'https://elzeviro-edb.ilporticoeditoriale.it:3030/static/media/copertinario/',
    make: 'https://elzeviro-edb.ilporticoeditoriale.it:8080/copertinario/make'
  },
  recensioni: {
    media: 'https://elzeviro-edb.ilporticoeditoriale.it:3030/static/media/recensioni/'
  },
  extra: {
    media: 'https://elzeviro-edb.ilporticoeditoriale.it:3030/static/media/extra/'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts